var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"image-view",attrs:{"name":_vm.k,"src":'/img/' + _vm.t(_vm.k)}})
}
var staticRenderFns = []

export { render, staticRenderFns }